/* eslint-disable no-self-assign */
import campaign from '@/api/campaign'
import course from '@/api/course'
import get from 'lodash/get'

const INITIAL_STATE = {
  summary: {},
  campaignList: {},
  campaignsStatusTotal: {},
  campaignDetails: null,
  createCampaignOptions: null,
  previewCourse: null,
}

export default {
  namespace: 'campaign',

  state: INITIAL_STATE,

  reducers: {
    init() {
      return { ...INITIAL_STATE }
    },
    setCampaignSummary(state, { payload }) {
      return { ...state, summary: payload }
    },
    setCampaignList(state, { payload }) {
      return { ...state, campaignList: payload }
    },
    setCampaignsStatusTotal(state, { payload }) {
      return { ...state, campaignsStatusTotal: payload }
    },
    setCampaignDetails(state, { payload }) {
      return { ...state, campaignDetails: payload }
    },
    setCreateCampaignOptions(state, { payload }) {
      return { ...state, createCampaignOptions: payload }
    },
    setCampaignUsers(state, { payload }) {
      const { campaignDetails = {} } = state

      return { ...state, campaignDetails: { ...campaignDetails, users: payload } }
    },
    setPreviewCourse(state, { payload }) {
      return { ...state, previewCourse: payload }
    },
  },

  effects: {
    *getCampaignSummary({ successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(campaign.getCampaignSummary, {
        params: { accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let hasError = true
      if (status === 200) {
        const { success, data } = resData
        if (success) {
          yield put({ type: 'campaign/setCampaignSummary', payload: data })
          hasError = false
          successCallback?.()
        }
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getCampaigns({ payload, skipPut, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(campaign.getCampaigns, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        hasError = false

        if (!skipPut) {
          yield put({ type: 'campaign/setCampaignList', payload: resData })
        }
        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getCampaignsStatusTotal({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(campaign.getCampaignsStatusTotal, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        const { success, data } = resData
        if (success) {
          hasError = false

          yield put({ type: 'campaign/setCampaignsStatusTotal', payload: data })
          successCallback?.()
        }
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getCampaignDetails({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)
      const { campaignId } = payload

      const response = yield call(campaign.getCampaignDetails, {
        campaignId,
        params: { params: { accountId: get(account, 'accountId') } },
      })
      const { status, data: resData } = response
      let hasError = true
      if (status === 200) {
        const { success, data } = resData
        if (success) {
          hasError = false

          yield put({ type: 'campaign/setCampaignDetails', payload: data })
          successCallback?.()
        }
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getCampaignUsers({ payload, successCallback, errorCallback }, { call, put }) {
      const { campaignId, params } = payload

      const response = yield call(campaign.getCampaignUsers, {
        campaignId,
        params: { params },
      })
      const { status, data: resData } = response
      let hasError = true
      if (status === 200) {
        hasError = false

        yield put({ type: 'campaign/setCampaignUsers', payload: resData })
        successCallback?.()
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getCampaignOptions({ successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(campaign.getCampaignOptions, {
        accountId: get(account, 'accountId'),
      })

      const { status, data: resData } = response
      let hasError = true
      if (status === 200) {
        const { success, data } = resData
        if (success) {
          hasError = false
          yield put({ type: 'campaign/setCreateCampaignOptions', payload: data })
          successCallback?.()
        }
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *sendCampaignReminders({ payload, successCallback, errorCallback }, { call }) {
      const response = yield call(campaign.sendCampaignReminders, payload)

      const { status, data: resData } = response

      let hasError = true
      if (status === 200) {
        const { success } = resData
        if (success) {
          hasError = false
          successCallback?.()
        }
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *createCampaign({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(campaign.createCampaign, {
        data: payload,
        accountId: get(account, 'accountId'),
      })

      const { status, data: resData } = response

      let hasError = true

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          hasError = false
          successCallback?.()
        } else if (message) {
          yield put({ type: 'app/notify', payload: { message, severity: 'error' } })
        }
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getCourseProgramDetails({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(course.getCourseProgramDetails, {
        courseId: get(payload, 'courseId'),
        accountId: get(account, 'accountId'),
      })

      const { status, data: resData } = response

      let hasError = true

      if (status === 200) {
        const { success, data } = resData
        if (success) {
          hasError = false
          yield put({ type: 'campaign/setPreviewCourse', payload: data })
          successCallback?.()
        }
      }
      if (hasError) {
        errorCallback?.()
      }
    },
  },
}
